module.exports = __webpack_public_path__ + "static/media/bulldogs-silhouette.70a7a6c9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/teamSilhouettes/bulldogs-silhouette.svg
// module id = 1325
// module chunks = 0